import React from 'react';
import { Tag } from 'antd';
import { 
  CheckCircleOutlined, 
  SyncOutlined, 
  CloseCircleOutlined, 
  ClockCircleOutlined,
  FileSearchOutlined
} from '@ant-design/icons';

export type StatusType = 'etl' | 'verification';

interface StatusBadgeProps {
  type: StatusType;
  status: string;
}

const StatusBadge: React.FC<StatusBadgeProps> = ({ type, status }) => {
  if (type === 'etl') {
    switch (status) {
      case 'processing':
        return <Tag icon={<SyncOutlined spin />} color="processing">Обработка</Tag>;
      case 'extracted':
        return <Tag icon={<CheckCircleOutlined />} color="success">Извлечено</Tag>;
      case 'failed':
        return <Tag icon={<CloseCircleOutlined />} color="error">Ошибка</Tag>;
      default:
        return <Tag icon={<ClockCircleOutlined />} color="default">Ожидание</Tag>;
    }
  }

  if (type === 'verification') {
    switch (status) {
      case 'verified':
        return <Tag icon={<CheckCircleOutlined />} color="success">Проверено</Tag>;
      case 'pending':
        return <Tag icon={<FileSearchOutlined />} color="warning">На проверке</Tag>;
      default:
        return <Tag color="default">{status}</Tag>;
    }
  }

  return <Tag color="default">{status}</Tag>;
};

export default StatusBadge;
